export default __webpack_public_path__ + "495b4571797edadf521d3bd99f15be20.woff";